export const CONSTANT_G_APP_NAME = 'meteoeffects';
export const CONSTANT_G_DIR_ORIGINAL = 'vorhersagen';
export const CONSTANT_G_DIR_EDITED = 'editiert';
export const CONSTANT_G_DIR_TEMPLATE = 'template';
export const CONSTANT_FIREBASE_BUCKET_BASE_PATH = `wetter/${CONSTANT_G_APP_NAME}`;

export const CONSTANT_G_BASE_URL_WRITE =
  'https://firebasestorage.googleapis.com/v0/b';
export const CONSTANT_G_BASE_URL_AUTH =
  'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword';

export const CONSTANT_AZURE_TENANT_ID = 'daaae532-0750-4b35-8f3f-fdd6ba4c86f0';
export const CONSTANT_AZURE_AUTHORIZED_GROUP = 'MeteoEffects';
